import React, { useState } from "react";
import { validateField } from "../utils/staticpackagedetails";
import { submitPackageDetails } from "../utils/services";
import { useSelector } from "react-redux";
import Popup from "react-popup";

const DetailsEnquiryModal = ({ closeModal, packageDetails, fareKey, resourceKeys}) => {
  const [formData, setFormData] = useState({
    title: "Mr",
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const culture = useSelector((state) => state.culture.currentCulture);
  const currency = useSelector((state) => state.currencyDetails);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: validateField(name, value, resourceKeys),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key], resourceKeys);
      if (error) newErrors[key] = error;
    });

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      setLoading(true);

      const requestBody = {
        PackageKey: fareKey,
        Email: formData.email,
        Title: formData.title,
        FirstName: formData.firstName,
        LastName: formData.lastName,
        MobileCode: "",
        MobileNumber: formData.mobile,
        Remarks: formData.message,
      };

      try {
        const response = await submitPackageDetails(requestBody, currency?.currentCurrency || 'en', culture);
        if (response?.Data && response?.Code == "200") {
            Popup.create({
              title: resourceKeys.tathkarah_title,
              content: resourceKeys.enquiry_submitted_successfully || 'Enquiry Submitted Successfully',
              buttons: {
                right: [
                  {
                    text: resourceKeys.ok,
                    action: function () {
                      Popup.close();
        
                    },
                  },
                ],
              },
            });
          } else {
            Popup.create({
              title: resourceKeys.tathkarah_title,
              content: resourceKeys.something_wrong,
              buttons: {
                right: [
                  {
                    text: resourceKeys.ok,
                    action: function () {
                      Popup.close();
                    },
                  },
                ],
              },
            });
          }
        closeModal();
      } catch (error) {
        alert(resourceKeys.error_submitting_enquiry);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div
      className="modal fade spackEnquiryModal show"
      id="exampleModal"
      tabIndex={-1}
      role="dialog"
      aria-labelledby="exampleModalLabel"
      style={{ display: "block", paddingRight: "17px" }}
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              {resourceKeys.enquiry_now}
            </h5>
            <button
              type="button"
              className="close"
              aria-label="Close"
              onClick={closeModal}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="packageName" className="col-form-label">
                <span>*</span> {resourceKeys.package_name || 'Package name'}
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="packageName"
                  name="packageName"
                  value={packageDetails?.PackageName || ""}
                  readOnly
                />
              </div>
              <div className="form-group">
                <label htmlFor="title"> <span>*</span> {resourceKeys.title || 'Title'}</label>
                <select
                  className="form-control"
                  id="title"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                >
                  <option value="Mr">{resourceKeys.mr || 'Mr'}</option>
                  <option value="Ms">{resourceKeys.mrs || 'Ms'}</option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="firstName" className="col-form-label">
                <span>*</span> {resourceKeys.first_name || 'First Name'}
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                />
                {errors.firstName && (
                  <small className="text-danger">{errors.firstName}</small>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="lastName" className="col-form-label">
                <span>*</span> {resourceKeys.last_name || 'Last Name'}
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                />
                {errors.lastName && (
                  <small className="text-danger">{errors.lastName}</small>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="email" className="col-form-label">
                <span>*</span> {resourceKeys.email || 'Email'}
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
                {errors.email && (
                  <small className="text-danger">{errors.email}</small>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="mobile" className="col-form-label">
                <span>*</span>{resourceKeys.mobile || 'Mobile'}
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="mobile"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                />
                {errors.mobile && (
                  <small className="text-danger">{errors.mobile}</small>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="message" className="col-form-label">
                <span>*</span>{resourceKeys.message || 'Message'}
                </label>
                <textarea
                  className="form-control"
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                />
                {errors.message && (
                  <small className="text-danger">{errors.message}</small>
                )}
              </div>
              <div className="modal-footer">
                <button type="submit" className="btn theme_btnStyle" disabled={loading}>
                  {loading ? resourceKeys.submitting+"..." : resourceKeys.submit || 'Submit'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailsEnquiryModal;
